import classnames from 'classnames';
import React from 'react';
import { Button, Card } from 'react-bootstrap';
import styles from './signUpSubscription.module.scss';
import SubscriptionUpsellEnterpriseItems from './SubscriptionUpsellEnterpriseItems';

interface SubscriptionUpsellEnterpriseProps {
  showButton?: boolean;
  onManage?: () => void;
}

const CONNECT_FEATURES = 'https://www.nomad-data.com/connect#connect-features';
const DRM_FEATURES =
  'https://www.nomad-data.com/data-relationship-manager#DRM-Super-Feature';

const SubscriptionUpsellEnterprise = ({
  showButton = false,
  onManage,
}: SubscriptionUpsellEnterpriseProps) => {
  const AddToYourSubscriptionButton = () => {
    return (
      <Button
        className={'btn-secondary-dark mt-3'}
        variant="secondary"
        onClick={onManage}
      >
        Add to your subscription
      </Button>
    );
  };

  const listItems = [
    <>
      Add your colleagues to share your DRM
      {showButton && <AddToYourSubscriptionButton />}
    </>,
    <>
      Add multiple Pro licenses
      {showButton && <AddToYourSubscriptionButton />}
    </>,
    <>
      <p key="connect-features">
        Explore other ways to engage with the world&apos;s largest data market,
        like browsing {buildHyperlink(CONNECT_FEATURES, 'New Providers')} or
        creating {buildHyperlink(CONNECT_FEATURES, 'Extended Requests')}
      </p>
    </>,
    <>
      <p key="drm-features">
        Explore using AI to search across all your data activity with{' '}
        {buildHyperlink(DRM_FEATURES, 'Data Concierge')} or all your documents
        with {buildHyperlink(DRM_FEATURES, 'Document Search')}
      </p>
    </>,
  ];

  return (
    <Card className={classnames('p-5 shadow-sm border-left-0', styles.root)}>
      <SubscriptionUpsellEnterpriseItems listItems={listItems} />
    </Card>
  );
};

export default SubscriptionUpsellEnterprise;

function buildHyperlink(link: string, title: string) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="text-primary font-weight-normal"
    >
      {title}
    </a>
  );
}
